import React, { useEffect, useState } from 'react';
import { getConsent, setConsent } from '../services/consent';

/**
 * GDPR/CCPA consent banner. Shows once until the user chooses; AdSlots stay dark
 * until consent is 'granted'.
 *
 * NOTE: when Ezoic goes live, switch to Ezoic's built-in CMP (proper TCF consent
 * strings) and have this component defer to it instead of managing the choice
 * locally. This local banner is the bridge until then.
 */
const ConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (getConsent() == null) setVisible(true);
  }, []);

  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4">
      <div className="mx-auto max-w-3xl bg-zinc-900 text-zinc-100 rounded-xl shadow-2xl border border-zinc-700 p-4 sm:flex sm:items-center sm:gap-4">
        <p className="text-sm text-zinc-300 flex-1 mb-3 sm:mb-0">
          We use cookies for analytics and to support the site with relevant ads on
          discovery pages. You can decline personalized ads — the site stays fully usable.
        </p>
        <div className="flex gap-2 flex-shrink-0">
          <button
            onClick={() => choose('denied')}
            className="px-4 py-2 text-sm rounded-lg border border-zinc-600 text-zinc-300 hover:bg-zinc-800 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={() => choose('granted')}
            className="px-4 py-2 text-sm rounded-lg bg-rose-600 hover:bg-rose-500 text-white font-medium transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
